// extracted by mini-css-extract-plugin
export default {"page":"Page_page__rBo02","body":"Page_body__gGTVQ"};